module.exports = __webpack_public_path__ + "images/106_1024.jpg";